export default __webpack_public_path__ + "static/media/Burial1New.ca8a5338.mp3";